import { T } from "@/constants/testIds";
import { fmtPct, fmtUsd } from "@/lib/format";

export default function Ticker({ stats, variant = "ink" }) {
  const items = [
    "Do it.",
    "Hood stays on",
    "We move in silence",
    "Outside? In this economy?",
    stats?.burn_percent != null ? `${fmtPct(stats.burn_percent)} burned forever` : "Burning supply",
    stats?.market_cap != null ? `MCAP ${fmtUsd(stats.market_cap)}` : "$DIH",
    "Robinhood Chain",
    "Not financial advice. Financial hoodie.",
  ];
  const lime = variant === "lime";
  const cls = lime ? "bg-lime text-ink border-ink" : "bg-ink text-lime border-black";

  return (
    <div
      className={`relative overflow-hidden border-y-2 py-4 md:py-5 ${cls}`}
      data-testid={T.ticker}
    >
      <div className="marquee-track">
        {[0, 1].map((k) => (
          <div key={k} className="flex items-center shrink-0">
            {items.map((t, i) => (
              <span
                key={i}
                className="font-display text-lg md:text-2xl uppercase px-6 md:px-8 flex items-center gap-6 md:gap-8 whitespace-nowrap"
              >
                {t}
                <span className={`w-2.5 h-2.5 rounded-full ${lime ? "bg-ink" : "bg-lime"}`} />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
